export const SUBLEASE_LIST = 'SUBLEASE_LIST';
export const ADD_SUBLEASE_LIST = 'ADD_SUBLEASE_LIST';
export const EDIT_SUBLEASE_SUCCESS = 'EDIT_SUBLEASE_SUCCESS';
export const SUBLEASE_CRUD = 'SUBLEASE_CRUD';
export const TOGGLE_VIEW_EDIT = 'TOGGLE_VIEW_EDIT';
export const SUBLEASE_LOADER = 'SUBLEASE_LOADER';
